<template>
  <div class="container">
    <el-carousel arrow="hover" class="banner" :autoplay="true" :interval="5000" :pause-on-hover="true">
      <el-carousel-item>
        <img :src="isMobile ? require('./images/bg1-mobile.png') : require('./images/bg1.png')" alt="致力于开发先进的脑机接口技术，实现大脑与数字世界的直接互联" class="banner-img">
      </el-carousel-item>
      <el-carousel-item>
        <div v-if="!isMobile" class="banner-btn home-btn-1" @click="toPage('/platformCloud')">点击获取方案</div>
        <img :src="isMobile ? require('./images/bg2-mobile.png') : require('./images/bg2.png')" alt="无缝衔接，赋能千行百业智慧新可能" class="banner-img">
      </el-carousel-item>
    </el-carousel>
    <div class="section-solutions home-large-padding">
      <div class="home-section-title">领先的脑机接口解决方案</div>
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="8">
          <div class="solution-card">
            <div class="solution-img-wrapper">
              <img src="./images/solution1.png" alt="超高分辨率">
            </div>
            <div class="solution-info">
              <h3 class="solution-title">超高分辨率</h3>
              <p class="solution-desc">我们的微电极阵列技术能够捕捉单个神经元的活动，支撑精确的神经信号解析与控制</p>
            </div>
          </div>
        </el-col>    

        <el-col :xs="24" :sm="24" :md="8">
          <div class="solution-card">
            <div class="solution-img-wrapper">
              <img src="./images/solution2.png" alt="长期稳定性">
            </div>
            <div class="solution-info">
              <h3 class="solution-title">长期稳定性</h3>
              <p class="solution-desc">生物相容性材料与自适应算法确保系统能够在体内长期稳定工作，减少免疫反应与信号衰减</p>
            </div>
          </div>
        </el-col>    

        <el-col :xs="24" :sm="24" :md="8">
          <div class="solution-card">
            <div class="solution-img-wrapper">
              <img src="./images/solution3.png" alt="超低功耗设计">
            </div>
            <div class="solution-info">
              <h3 class="solution-title">超低功耗设计</h3>
              <p class="solution-desc">创新的芯片设计与信号处理算法，大幅降低系统功耗，实现小型化与长时间使用</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="section3">
      <div class="home-section-title">改变未来的应用场景</div>
      <div class="section3-indicator home-large-padding">
        <div class="section3-indicator-item" :class="{'section3-indicator-active':section3Index===0}"
          @click="changeCard(0)">健康</div>
        <div class="section3-indicator-item" :class="{'section3-indicator-active':section3Index===1}"
          @click="changeCard(1)">学术</div>
        <div class="section3-indicator-item" :class="{'section3-indicator-active':section3Index===2}"
          @click="changeCard(2)">用户体验</div>
      </div>
      <div class="flex-between home-large-padding">
        <el-carousel ref="carousel" indicator-position="none" arrow="never" style="width:100%;height:48vh;"
          @change="handleCardChange">
          <el-carousel-item>
            <div class="section3-card">
              <h2 class="section3-card-title">健康研究</h2>
              <div class="section3-card-sub">脑认知与神经科学研究</div>
              <div class="section3-card-sub">人机工效性和医疗器械的可用性评估研究</div>
              <div class="section3-card-sub">基于XR虚实融合的认知功能评测研究</div>
              <h3 class="section3-card-con">
                经方智脑基于自研人机环同步平台、智能分析系统及多模态生理采集技术，为智慧健康领域的人机功效评估、健康状态监测与神经科学研究提供全面的数据采集与分析支撑
              </h3>
              <div class="home-btn section3-card-btn" @click="toPage('/productClose')">了解更多</div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="section3-card section3-card-2">
              <h2 class="section3-card-title">学术研究</h2>
              <div class="section3-card-sub">人员测试训练与健康康复</div>
              <div class="section3-card-sub">心理与认知神经科学</div>
              <div class="section3-card-sub">人工智能与智能决策</div>
              <h3 class="section3-card-con">
                经方智脑依托自研人机环同步平台与多模态生理-行为数据技术，为心理学、人工智能等多领域打造全链路智能研究支撑平台，助力跨学科研究与理论突破，驱动学术创新。
              </h3>
              <div class="home-btn section3-card-btn" @click="toPage('/productChargeHw')">了解更多</div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="section3-card section3-card-3">
              <h2 class="section3-card-title">用户体验研究</h2>
              <div class="section3-card-sub">可视化人机界面设计用户体验测评</div>
              <div class="section3-card-sub">基于老年用户使用体验的适老界面设计研究</div>
              <div class="section3-card-sub">脑控交互驱动的健康场景产品设计研究</div>
              <h3 class="section3-card-con">
                用户体验研究融合脑控交互、眼动追踪与可用性测试技术，精准洞察用户需求与行为，优化产品设计，打造直觉交互体验，提升用户满意度。
              </h3>
              <div class="home-btn section3-card-btn" @click="toPage('/productAcs')">了解更多</div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="section4 home-large-padding">
      <div class="home-section-title">全栈脑机产品矩阵</div>
      <div class="accordion-container">
        <div 
          v-for="(item, index) in cardList" 
          :key="index"
          class="card"
          :class="{ 'active': activeIndex === index }"
          @mouseenter="activeIndex = index"
        >
          <div class="card-bg" :style="{ backgroundImage: `url(${require('./images/section4-'+(index+1)+'.png')})` }"></div>
          
          <div class="overlay"></div>
  
          <div class="collapsed-label" v-show="activeIndex !== index">
            {{ item.title }}
          </div>
  
          <div class="content">
            <div class="logo-box">{{ item.logo }}</div>
            <p class="desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="section5 home-large-padding">
      <div class="home-section-title">专业合作伙伴</div>
      <el-row :gutter="30">
        <el-col :xs="24" :sm="24" :md="8">
          <div class="section5-card">
            <div class="section5-img-wrapper">
              <img src="./images/section5-1.png" alt="招商银行">
            </div>
          </div>
        </el-col>    

        <el-col :xs="24" :sm="24" :md="8">
          <div class="section5-card">
            <div class="section5-img-wrapper">
              <img class="img" src="./images/section5-2.png" alt="北京科技大学">
            </div>
          </div>
        </el-col>

        <el-col :xs="24" :sm="24" :md="8">
          <div class="section5-card">
            <div class="section5-img-wrapper">
              <img class="img" src="./images/section5-3.png" alt="车易付">
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
  import { ElCarousel, ElCarouselItem, ElRow, ElCol } from 'element-plus'
  // import countUp from 'vue-countup-v3';
  import news from './../news/data.js'
  let timer;

  export default {
    components: { ElCarousel, ElCarouselItem, ElRow, ElCol },
    data() {
      return {
        clientWidth: '',
        section3Index: 2,
        isMobile: false,
        activeIndex: 0,
        cardList: [
          {
            title: '脑机帽PRO-1号',
            logo: '脑机帽PRO-1号',
            desc: '这是一款专为家庭场景设计的轻量化脑电监测设备，采用简洁的佩戴设计与友好的交互界面，让你在家就能轻松追踪大脑状态。设备实时采集并分析脑电信号，通过配套小程序直观呈现专注度、放松度等数据，帮助你了解自身的情绪波动与认知负荷。用于家庭场景下的专注力训练与心理健康观察，让脑科学走进日常生活。',
            bg: './images/section4-1.png'
          },
          {
            title: '脑机管理平台',
            logo: '脑机管理平台',
            desc: '经方智脑 PC 管理平台，让脑机科研从容掌控。一键绑定多台设备，实时同步状态与采集进度；毫秒级捕捉脑电波形，异常数据实时预警；内置分析模板，一键生成可视化报告；全程可视化监控实验，自动存日志，让科研更高效稳定。',
            bg: './images/section4-2.png'
          },
          {
            title: '经方智脑小程序',
            logo: '经方智脑小程序',
            desc: '一键连接脑机设备，精准采集脑电信号，实时反馈大脑状态，无需繁琐设置，居家、办公、休闲时都能随时开启脑健康探索。在这里，你可以轻松解锁脑控交互新体验，感受丝滑流畅的操作与连接，让大脑状态可视化，每一次健康监测都清晰、可靠又自在。',
            bg: './images/section4-3.png'
          },
        ]
      }
    },
    created() {
      const mediaQuery = window.matchMedia("(max-width: 768px)");
      this.isMobile = mediaQuery.matches;
      localStorage.setItem('isMobile', this.isMobile);
      // 监听媒体查询变化
      mediaQuery.addEventListener("change", (e) => {
        this.isMobile = e.matches;
        localStorage.setItem('isMobile', this.isMobile);
      });
    },
    mounted() {
      if (this.isMobile === 'false') {
        // this.init()
      }
    },
    beforeDestroy() {
      timer && clearInterval(timer)
    },
    methods: {
      toPage(url) {
        // this.$router.push(url)
      },
      toCaseDetail(id) {
        window.localStorage.setItem('casesId', id)
        this.$router.push("/cases-detail")
      },
      changeCard(type) {
        // 手动切换智能化硬件产品
        this.section3Index = type
        this.$refs.carousel.setActiveItem(type)
      },
      handleCardChange() {
        // 自动切换智能化硬件产品
        this.section3Index = this.$refs.carousel.activeIndex
      },
      getTranslateX(element) {
        const style = window.getComputedStyle(element);
        const transform = style.transform;

        if (transform.includes('translateX')) {
          const match = transform.match(/translateX\(([^)]+)px\)/);
          if (match) {
            return parseFloat(match[1]);
          }
        }

        return 0;
      }

    }
  }

</script>
<style lang="less" scoped>
  .banner,
  .banner .el-carousel-item {
    position: relative;
    padding: 7.4vh 0 0;
    width: 100%;
    color: #fff;
  }

  .home-btn,
  .banner-btn {
    background: #020814;
    border-radius: 60px;
    font-weight: 700;
    font-size: 32px;
    color: #FFFFFF;
    text-align: center;
    cursor: pointer;
  }

  .home-btn:hover {
    background: #020814;
  }

  .home-btn-3:active {
    background: #020814;
  }

  .home-btn-1 {
    background: #fff;
    color: #020814;
  }

  .home-btn-2 {
    background: #F3C583;
    color: #5E3A06;
  }

  .banner .home-btn,
  .banner .banner-btn {
    position: absolute;
    left: 16.1vw;
    bottom: 12.3%;
  }


  @media (max-width: 768px) {
    .banner {
      height: 900px;
      /* 小屏幕高度 */
    }

    .home-large-padding {
      padding: 0 5vw;
    }

    .home-btn,
    .banner-btn {
      width: 280px;
      height: 68px;
      line-height: 66px;
    }

    .home-section-title {
      padding: 3vh 0 !important;
      text-align: center;
      font-size: 60px !important;
      font-weight: 550;
    }
    // 领先的脑机接口解决方案
    .solution-card {
      margin-bottom: 40px;
  }

    .company-title {
      margin-top: 30px;
    }
    .section-solutions {
      padding-top: 40px;
      padding-bottom: 20px;
      
      .solution-img-wrapper {
        height: 200px;
      }
      
      .solution-title {
        font-size: 42px !important;
      }
    }
    .section5 {
      padding-top: 4vh;
      padding-bottom: 4vh;
      
      .section5-img-wrapper {
        height: 10vh;
      }
    }
    /* 容器高度修复 */
    .section3 {
      background: #F7F8FA;

      /* 强制给 Element 走马灯容器高度，否则在移动端会塌陷 */
      :deep(.el-carousel__container) {
        height:  49vh !important; 
      }
    }

    /* Tab 容器：改为居中并控制整体宽度 */
    .section3-indicator {
      display: flex;
      justify-content: center; /* 居中 */
      gap: 15px;               /* 选项之间的间距 */
      margin-bottom: 24px !important;
      padding: 0 !important;
      font-size: 36px !important;
      width: 100%;
    }

    /* 单个 Tab 项目：固定宽度 */
    .section3-indicator-item {
      width: 150px !important;   /* 固定一个合适的宽度 */
      flex-shrink: 0;          /* 防止被压缩 */
      padding-bottom: 8px !important;
      text-align: center;
      border-bottom-width: 5px !important; /* 线条稍微细一点更精致 */
      cursor: pointer;
      white-space: nowrap;     /* 强制文字不换行 */
    }

    /* 移除 PC 端的特定边距 */
    .section3-indicator-item:nth-child(2) {
      margin: 0 !important;
    }

    .section3-indicator-active {
      width: 140px !important;
    }

    /* 卡片重构：图片在上，文字在下 */
    .section3-card {
      display: flex !important;
      flex-direction: column !important;
      height: 100% !important;
      padding: 0 0 20px !important;
      background-image: none !important; /* 禁用 PC 端的背景图逻辑 */
      background-color: #fff !important;
      border-radius: 12px;
    }

    /* 模拟顶部图片区：利用伪元素把背景图放回顶部 */
    .section3-card::before {
      content: "";
      display: block;
      width: 100%;
      height: 500px; /* 移动端图片高度 */
      background-size: cover;
      background-position: center;
      border-radius: 12px 12px 0 0;
    }

    /* 分别指定三张图片 */
    .section3-card.section3-card::before { background-image: url('./images/section3-1.png'); }
    .section3-card.section3-card-2::before { background-image: url('./images/section3-2.png'); }
    .section3-card.section3-card-3::before { background-image: url('./images/section3-3.png'); }

    /* 文字内容微调 */
    .section3-card-title {
      font-size: 42px !important;
      padding: 20px 40px !important;
      color: #020814;
    }

    .section3-card-sub {
      font-size: 32px !important;
      margin-bottom: 15px !important;
      padding-left: 40px !important;
      margin-left: 40px;
      background-size: 26px 26px !important;
      font-weight: normal !important;
    }

    .section3-card-con {
      font-size: 30px !important;
      line-height: 1.2 !important;
      padding: 20px 40px !important;
      margin-bottom: 15px !important;
      color: #4E5969 !important;
    }

    .section3-card-btn {
      margin: 0 40px 40px !important;
      width: 220px !important;
      height: 72px !important;
      line-height: 72px !important;
      font-size: 26px !important;
    }
    
  }

  @media (min-width: 769px) {
    .banner {
      height: 33vw;
      /* 大屏幕高度 */
    }

    .home-large-padding {
      padding: 0 12.5vw;
    }

    .home-btn,
    .banner-btn {
      width: 480px;
      height: 100px;
      line-height: 100px;
    }


    .section3-card {
      padding: 0 48vw 0 2vw;
      background-position: right center;
      background-size: 46vw 100%;
    }

    .section3-card-2,
    .section3-card-3 {
      background-size: 46vw 100%;
    }

    .section3-card-title {
      padding-bottom: 2vh;
    }

    .section3-card-con {
      margin-bottom: 4vh;
    }


    .company-title {
      margin-top: 10.5vh;
    }
  }

  .banner-img {
    width: 100%;
    height: 100%;
  }

  .section5 {
    background-color: #F7F8FA;
  }


  .section5-img-wrapper {
    height: 12vh;
  }

  @keyframes marquee {
    0% {
      transform: translateX(10);
    }

    100% {
      transform: translateX(-100%);
    }
  }

  .section4,
  .section3 {
    background: #F7F8FA;
  }

  .section3 {
    
    &-card {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      height: 47.4vh;
      border-radius: 16px;
      background-repeat: no-repeat;
      background-color: #fff;
      background-image: url('./images/section3-1.png');
    }

    &-card-2 {
      background-image: url('./images/section3-2.png');
    }

    &-card-3 {
      background-image: url('./images/section3-3.png');
    }

    &-card-title {
      font-weight: 700;
      font-size: 60px;
    }

    &-card-sub {
      margin-bottom: 40px;
      padding-left: 60px;
      font-weight: 700;
      font-size: 36px;
      background: url(./images/section3-icon.png) left center no-repeat;
      background-size: 36px 36px;
    }

    &-card-btn {
      color: #fff;
      background-color: #020814;
    }

    &-card-con {
      font-size: 32px;
      font-weight: normal;
      color: #4E5969;
      line-height: 56px;
    }

    &-indicator {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 64px;
      color: #4E5969;
      font-size: 40px;
    }

    &-indicator-item {
      padding-bottom: 46px;
      cursor: pointer;
      width: 180px;
      text-align: center;
      border-bottom: 6px solid transparent;
    }

    &-indicator-item:nth-child(2) {
      margin: 0 12vw;
    }

    &-indicator-active {
      color: #020814;
      font-weight: 700;
      border-bottom: 8px solid #020814;
    }

  }

  .home-section-title {
    padding: 10.2vh 0 5.5vh;
    text-align: center;
    font-size: 80px;
    font-weight: 550;
    // background-color: #F7F8FA;
  }

  .section-padding {
    padding: 0 3vw;
  }

  .section1 {
    &-item {
      flex: 1;
      justify-content: center;
      height: 15.8vh;
      font-size: 32px;

      &-num {
        padding-bottom: 2vh;
        line-height: 1;
        font-weight: 700;
        font-size: 88px;
        color: #020814;
      }

      &-unit {
        font-weight: 700;
        font-size: 28px;
        color: #020814;
      }
    }
  }

  /* 解决方案部分样式 */
  .company-title {
    padding-bottom: 4vh;
    font-weight: 550;
    font-size: 80px;
    line-height: 88px;
  }

  .company-detail {
    font-size: 36px;
  }

  .custom-indicators button {
    /* 自定义指示器的样式 */
    margin: 0 5px;
    padding: 5px;
    background-color: red;
    border: none;
    cursor: pointer;
  }

  .custom-indicators button.active {
    background-color: #409EFF;
    color: white;
  }

  /* 脑机接口解决方案模块样式 */
.section-solutions {
  background-color: #F7F8FA;
  box-sizing: border-box;

  .solution-card {
    transition: transform 0.3s ease;
    
    &:hover {
      transform: translateY(-5px);
    }

    .solution-img-wrapper {
      width: 100%;
      height: 29vh; // 根据实际视觉效果调整高度
      overflow: hidden;
      border-radius: 16px 16px 0 0; // 略微圆角
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover; // 确保图片不变形填满容器
      }
    }

    .solution-info {
      padding: 40px;
      text-align: left;
      color: #020814;
      background-color: #fff;
      border-radius: 0 0 16px 16px;
      // height: 18vh;

      .solution-title {
        font-size: 60px;
        font-weight: 600;
        margin-bottom: 20px;
      }

      .solution-desc {
        font-size: 36px;
        line-height: 1.4;
      }
    }
  }
}
/* 专业合作伙伴模块样式 */
.section5 {
  // padding-top: 8vh;
  padding-bottom: 8vh;
  background-color: #F7F8FA;

  .section5-card {
    margin-bottom: 30px;

    .section5-img-wrapper {
      width: 100%;
      height: 12vh; // 根据实际视觉效果调整高度
      overflow: hidden;
      border-radius: 16px; // 略微圆角
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover; // 确保图片不变形填满容器
      }
    }
  }
}

.accordion-container {
  display: flex;
  width: 100%;
  height: 50vh;
  gap: 12px;
}

/* 基础卡片 */
.card {
  position: relative;
  flex: 1; /* 默认等宽 */
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  transition: flex 0.6s cubic-bezier(0.25, 1, 0.5, 1);
  border-radius: 16px;
}

/* 激活态：flex占比变大 */
.card.active {
  flex: 5;
}

/* 背景图及其动画 */
.card-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  transition: transform 0.8s ease;
  border-radius: 16px;
}
.card.active .card-bg {
  transform: scale(1.05);
}

/* 渐变遮罩 */
.overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, rgba(0,0,0,0) 30%, rgba(0,0,0,0.8) 100%);
  z-index: 1;
}

/* 未展开时的标题 */
.collapsed-label {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
  color: #fff;
  font-weight: bold;
  font-size: 36px;
  z-index: 2;
  // writing-mode: vertical-rl; /* 模拟垂直排列（可选） */
  letter-spacing: 4px;
}

/* 展开后的内容 */
.content {
  position: absolute;
  bottom: 40px;
  left: 40px;
  right: 40px;
  color: #fff;
  z-index: 3;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.5s ease 0.1s;
}

.card.active .content {
  opacity: 1;
  transform: translateY(0);
}

.logo-box { 
  font-size: 64px; 
  font-weight: 800;
  margin-bottom: 20px; }
.desc { 
  font-size: 36px; 
  line-height: 1.8; 
  margin-bottom: 30px; 
  max-width: 60vw; 
  color: rgba(255,255,255,0.9); 
}
@media (max-width: 768px) {
  /* 1. 调整容器：取消 flex 布局，高度自适应 */
  .accordion-container {
    display: block;      /* 取消 flex，让卡片纵向排列 */
    height: auto;        /* 高度随内容撑开 */
  }

  /* 2. 调整卡片：改为静态展示，取消动画过渡 */
  .card {
    display: flex;
    flex-direction: column;
    width: 100% !important;
    height: auto !important; /* 取消固定高度 */
    margin-bottom: 40px;     /* 卡片间距 */
    background: #fff;        /* 移动端建议使用白底，增加可读性 */
    transition: none !important; /* 彻底移除动画 */
  }
  .card:last-child {
    margin-bottom: 0;
  }

  /* 3. 调整背景图：作为卡片顶部的封面图 */
  .card-bg {
    position: relative;
    height: 400px;           /* 固定图片高度 */
    width: 100%;
    transform: none !important;
    border-radius: 16px 16px 0 0;
  }

  /* 4. 隐藏不需要的元素 */
  .overlay, 
  .collapsed-label {
    display: none !important; /* 移动端不再需要遮罩和侧边标签 */
  }

  /* 5. 调整内容区：让文字回归到文档流中，颜色设为深色 */
  .content {
    position: static;        /* 脱离绝对定位 */
    padding: 40px;
    opacity: 1 !important;    /* 强制显示 */
    transform: none !important;
    background: #fff;
    color: #020814;          /* 改为深色文字 */
  }

  .logo-box {
    font-size: 40px;         /* 适配手机标题大小 */
    font-weight: 700;
    margin-bottom: 12px;
    color: #020814;
  }

  .desc {
    font-size: 32px;         /* 适配手机正文字号 */
    line-height: 1.6;
    color: #4E5969;
    max-width: 100%;
    margin-bottom: 0;
    text-align: justify;     /* 两端对齐，更整齐 */
  }
}
</style>